import { Navigate } from "react-router-dom";
import Devices from "../../components/directory/Devices";
import UserDetails from "../../components/directory/UserDetails";
import UserDetailsGroups from "../../components/directory/UserDetailsGroups";
import UserDetailsProfile from "../../components/directory/UserDetailsProfile";

const directoryRouter = [
    { path: "devices", element: <Devices /> },
    { path: "userDetails", element: <UserDetails /> },
    { path: "userDetailsGroups", element: <UserDetailsGroups /> },
    { path: "userDetailsProfile", element: <UserDetailsProfile /> },
    // Platform users now live in Settings → Users & Access. This is a legacy
    // path kept so existing deep links keep resolving.
    { path: "platform-users", element: <Navigate to="/pam/settings/users" replace /> }
];

export default directoryRouter;